import { ClipboardCheckIcon, FactoryIcon, FileBadgeIcon, PersonStandingIcon, PillIcon, TestTubesIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Pharmaceutical Manufacturing Fundamentals: Dosage Forms, the Production Flow & the Plant',
    summary: 'A visual technical reference to how medicines are made, from API and excipients to dosage forms, the production flow and the areas of a pharmaceutical plant.',
    icon: PillIcon,
  },
  {
    number: '02',
    title: 'GMP & the Pharmaceutical Quality System: Documentation, Deviations, CAPA & Change Control',
    summary: 'A visual technical reference to GMP principles, good documentation practice, deviations, root cause analysis, CAPA and change control.',
    icon: FileBadgeIcon,
  },
  {
    number: '03',
    title: 'Cleanrooms & Contamination Control: Classification, HVAC, Gowning & Environmental Monitoring',
    summary: 'A visual technical reference to cleanroom grades, airlocks, pressure cascades, HEPA filtration, gowning and environmental monitoring.',
    icon: PersonStandingIcon,
  },
  {
    number: '04',
    title: 'Solid & Liquid Dosage Manufacturing: Granulation, Compression, Coating, Encapsulation & Liquids',
    summary: 'A visual technical reference to blending, granulation, drying, tablet compression, coating, capsule filling, in-process controls and oral liquids.',
    icon: FactoryIcon,
  },
  {
    number: '05',
    title: 'Sterile Manufacturing & Aseptic Processing: Sterilization, Aseptic Filling & Lyophilization',
    summary: 'A visual technical reference to sterilization methods, filtration, isolators and RABS, aseptic filling, media fills and freeze-drying.',
    icon: TestTubesIcon,
  },
  {
    number: '06',
    title: 'Validation, Qualification, Data Integrity, Audits & Inspections',
    summary: 'A visual technical reference to IQ/OQ/PQ, process and cleaning validation, ALCOA+ data integrity, audits and inspections.',
    icon: ClipboardCheckIcon,
  },
];
